import React from "react";
import ByIndustryComp from "../../component/solutionscomponent/ByIndustryComp";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";

const ByIndustry = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <ByIndustryComp />
        <Footer />
      </section>
    </>
  );
};

export default ByIndustry;
